// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__2zLcS","mobileWrapper":"style_mobileWrapper__2QVem","logo":"style_logo__2vA2b","mobileLogo":"style_mobileLogo__2r_4B"};